import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardShell from "@/components/DashboardShell";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import ConnectPage from "@/pages/ConnectPage";
import MappingPage from "@/pages/MappingPage";
import HealthPage from "@/pages/HealthPage";
import SettingsPage from "@/pages/SettingsPage";
import ForecastPage from "@/pages/ForecastPage";
import RiskRadarPage from "@/pages/RiskRadarPage";
import FunnelPage from "@/pages/FunnelPage";
import TeamPage from "@/pages/TeamPage";
import BookingsPage from "@/pages/BookingsPage";
import BriefingsPage from "@/pages/BriefingsPage";
import PaywallPage from "@/pages/PaywallPage";
import LandingPage from "@/pages/LandingPage";
import PrivacyPage from "@/pages/PrivacyPage";
import FaqPage from "@/pages/FaqPage";
import VsHubSpotPage from "@/pages/VsHubSpotPage";
import ImprintPage from "@/pages/ImprintPage";
import AdminPage from "@/pages/AdminPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import UnsubscribePage from "@/pages/UnsubscribePage";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/imprint" element={<ImprintPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/vs-hubspot" element={<VsHubSpotPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute allowPaywall>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
            <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
            <Route path="/unsubscribe/:token" element={<UnsubscribePage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route
              path="/billing/upgrade"
              element={
                <ProtectedRoute allowPaywall>
                  <PaywallPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardShell>
                    <Navigate to="/dashboard/forecast" replace />
                  </DashboardShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/forecast"
              element={
                <ProtectedRoute>
                  <DashboardShell>
                    <ForecastPage />
                  </DashboardShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/risk"
              element={
                <ProtectedRoute>
                  <DashboardShell>
                    <RiskRadarPage />
                  </DashboardShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/funnel"
              element={
                <ProtectedRoute>
                  <DashboardShell>
                    <FunnelPage />
                  </DashboardShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/team"
              element={
                <ProtectedRoute>
                  <DashboardShell>
                    <TeamPage />
                  </DashboardShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/bookings"
              element={
                <ProtectedRoute>
                  <DashboardShell>
                    <BookingsPage />
                  </DashboardShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/briefings"
              element={
                <ProtectedRoute>
                  <DashboardShell>
                    <BriefingsPage />
                  </DashboardShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/connect"
              element={
                <ProtectedRoute>
                  <DashboardShell>
                    <ConnectPage />
                  </DashboardShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/mapping"
              element={
                <ProtectedRoute>
                  <DashboardShell>
                    <MappingPage />
                  </DashboardShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/health"
              element={
                <ProtectedRoute>
                  <DashboardShell>
                    <HealthPage />
                  </DashboardShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/settings"
              element={
                <ProtectedRoute allowPaywall>
                  <DashboardShell>
                    <SettingsPage />
                  </DashboardShell>
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
